import { render, staticRenderFns } from "./Edit2.vue?vue&type=template&id=6b4c4cc9&scoped=true&"
import script from "./Edit2.vue?vue&type=script&lang=js&"
export * from "./Edit2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4c4cc9",
  null
  
)

export default component.exports